export const liveProducts = [
  {
    slug: "jazzys-burger",
    name: "Jazzy's Burger",
    externalUrl: "https://jazzysburger.com",
    caseStudyPath: "/caseStudy/jazzysburger",
    intro: [
      "End-to-end ordering for a multi-location QSR brand: consumer apps, web checkout, payments, and operations admin.",
      "Live across Nigeria since 2022.",
    ],
  },
  {
    slug: "eve-after-dark",
    name: "Eve After Dark",
    externalUrl: "https://theeveafterdark.co.uk",
    caseStudyPath: "/caseStudy/ead",
    intro: [
      "Ordering and kitchen operations for a cloud kitchen brand in Nigeria and the UK.",
      "Inventory, branches, and fulfilment across multiple locations including London.",
    ],
  },
  {
    slug: "awashop",
    name: "AwaShop",
    externalUrl: "https://awashop.ng",
    intro: [
      "Merchant platform for online storefronts, catalogue management, and card payments.",
      "Self-serve onboarding so businesses can publish a shop and take orders without bespoke builds.",
    ],
  },
  {
    slug: "sendchops",
    name: "Sendchops",
    externalUrl: "https://sendchops.com",
    intro: [
      "Cross-border commerce: customers abroad pay in local currency; orders are fulfilled in Nigeria.",
      "Launching 2026.",
    ],
  },
];

export const earlierWork = [
  {
    name: "Vault Hill",
    description: "Past client project: marketing website for Vault Hill.",
    path: "/blog/vaultHill",
    externalUrl: "https://vaulthill.ai",
  },
];
